import fieldTypes from '/programs/form-fields-renderer/field-row/field-types.js';

function validateFileField(index, fieldRow, fileInputRenderer) {

  if (fileInputRenderer.isValid() === true) {
    return true;
  }

  fileInputRenderer.displayError();

  throw new Error('File input not valid');

}

function validate(form, fieldRows, formFieldsRenderer) {

  if (form.checkValidity() === false) {
    form.reportValidity();
    throw new Error('Form not valid');
  }

  const fieldRowsLength = fieldRows.length;

  const fieldViews = formFieldsRenderer.el.views;

  for (let index = 0; index < fieldRowsLength; index++) {

    const fieldRow = fieldRows[index];
    const fieldView = fieldViews[index];

    if (fieldRow.type === fieldTypes.FILE) {
      this.validateFileField(index, fieldRow, fieldView.inputRenderer);
    }

  }

}

const validationUtilities = {
  validateFileField,
  validate
};

export default validationUtilities;